import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import AmountDetails from "../AmountDetails";
import ModelProxyClass from "./ModelProxyClass";


/**
 * @class AmountDetailsBase
 * @extends ModelBaseClass
 * @property {number} d1 (integer) count of $1 bills
 * @property {number} d5 (integer) count of $5 bills
 * @property {number} d10 (integer) count of $10 bills
 * @property {number} d20 (integer) count of $20 bills
 * @property {number} d50 (integer) count of $50 bills
 * @property {number} d100 (integer) count of $100 bills
 * @property {number} c1 (integer) count of 1 cent pennies
 * @property {number} c5 (integer) count of 5 cent pennies
 * @property {number} c10 (integer) count of 10 cent pennies
 * @property {number} c25 (integer) count of 25 cent pennies
 * @property {number} mixed total value of non-separated bills and coins
 */
class AmountDetailsBase extends ModelBaseClass {
	/**
	 * count of $1 bills
	 * @type {number} d1 (integer)
	 */
	d1;
	/**
	 * count of $5 bills
	 * @type {number} d5 (integer)
	 */
	d5;
	/**
	 * count of $10 bills
	 * @type {number} d10 (integer)
	 */
	d10;
	/**
	 * count of $20 bills
	 * @type {number} d20 (integer)
	 */
	d20;
	/**
	 * count of $50 bills
	 * @type {number} d50 (integer)
	 */
	d50;
	/**
	 * count of $100 bills
	 * @type {number} d100 (integer)
	 */
	d100;
	/**
	 * count of 1 cent pennies
	 * @type {number} c1 (integer)
	 */
	c1;
	/**
	 * count of 5 cent pennies
	 * @type {number} c5 (integer)
	 */
	c5;
	/**
	 * count of 10 cent pennies
	 * @type {number} c10 (integer)
	 */
	c10;
	/**
	 * count of 25 cent pennies
	 * @type {number} c25 (integer)
	 */
	c25;
	/**
	 * total value of non-separated bills and coins
	 * @type {number} mixed
	 */
	mixed;

	/**
	 * Instantiates a new instance of AmountDetails based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {AmountDetails}
	 */
	static create(genericObject) {
		const newAmountDetails = new AmountDetails();
		newAmountDetails.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newAmountDetails;
	}

	/**
	 * Instantiates a new array of AmountDetails based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[AmountDetails]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newAmountDetailsArray = [];
		genericArray.forEach(genericObject => {
			newAmountDetailsArray.push(AmountDetails.create(genericObject));
		});
		return newAmountDetailsArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('d1', 'integer'),
	ModelBaseClass.createModelProperty('d5', 'integer'),
	ModelBaseClass.createModelProperty('d10', 'integer'),
	ModelBaseClass.createModelProperty('d20', 'integer'),
	ModelBaseClass.createModelProperty('d50', 'integer'),
	ModelBaseClass.createModelProperty('d100', 'integer'),
	ModelBaseClass.createModelProperty('c1', 'integer'),
	ModelBaseClass.createModelProperty('c5', 'integer'),
	ModelBaseClass.createModelProperty('c10', 'integer'),
	ModelBaseClass.createModelProperty('c25', 'integer'),
	ModelBaseClass.createModelProperty('mixed', 'float'),
];

export default AmountDetailsBase;
